import "regenerator-runtime/runtime.js";
import { addErrorHandler, getMountedApps, registerApplication, start } from "single-spa";
import postal from "postal";
import { applicationConfigs } from "./config/applicationsConfigs";
import authConfig from "./config/authConfigs";
import { authenticatedFetch, configure } from "@nutrien/cxp-api-fetch-module";
import { getCurrentSession, configure as configureAuth } from "@nutrien/cxp-auth-module";
import { IAXPOrchestrator, User } from "@nutrien/axp-orchestrator-module/build/interfaces";
import { getPermissions } from "./api/permissionsAPI";
import { callAPI } from "./api/apiUtilities";

addErrorHandler(error => {
  console.log(error);
});

const setInitialUrl = (url: string) => {
  if (window.sessionStorage) {
    window.sessionStorage.setItem("initial-url", url);
  }
};

const getInitialUrl = () => {
  if (window.sessionStorage) {
    return window.sessionStorage.getItem("initial-url") ?? "";
  }
  return "";
};

if (!window.location.href.toLowerCase().includes("login") && !window.location.href.toLowerCase().includes("logout")) {
  setInitialUrl(window.location.href);
}

// Configure auth function for authenticated fetch to work in child apps
configure(authConfig);
configureAuth(authConfig);

// A shared channel for triggering events across Micro FrontEnds
export const channel = postal.channel("main");

//todo - does this really matter?  remove?
const isSidebarOpen = () => false;

function buildAxpOrchestratorModule(): IAXPOrchestrator {
  return {
    channel: {
      subscribe: (topic, func) => channel.subscribe(topic, func),
      send: (topic, data) => channel.publish(topic, data)
    },
    callAPI,
    authenticatedFetch,
    authConfig: authConfig,
    isSidebarOpen,
    getCurrentUser: () => currentUser,
    initializeCurrentUser: () => initializeSecurity()
  };
}

window.addEventListener("single-spa:app-change", () => {
  console.log("single-spa app change");
  channel.publish(
    "axp-mounted-application-change",
    getMountedApps().map(x => x.split("/")[1])
  );
});

const currentUser: User = {
  email: "",
  userId: 0,
  firstName: "Ned",
  lastName: "Kelly",
  isAuthenticated: false,
  securityGroups: []
};

function registerAllApplications() {
  for (const config of applicationConfigs) {
    registerApplication(
      config.appName,
      x => System.import(config.moduleId),
      config.activityFunction,
      buildAxpOrchestratorModule()
    );
  }
}

function setUserProfile(session: any) {
  if (session.isValid()) {
    const payload = session.getIdToken().payload;
    currentUser.isAuthenticated = true;
    currentUser.firstName = payload.given_name;
    currentUser.lastName = payload.family_name;
    currentUser.email = payload.email;
  }
}

const initializeSecurity = async () => {
  currentUser.email = "";
  currentUser.userId = 0;
  currentUser.firstName = "";
  currentUser.lastName = "";
  currentUser.isAuthenticated = false;
  currentUser.securityGroups = [];

  const session = await getCurrentSession();
  setUserProfile(session);
  let permissions = await getPermissions();

  if (session.isValid() && permissions.toString().includes("No current user")) {
    while (permissions.toString().includes("No current user")) {
      await new Promise(resolve => setTimeout(resolve, 500));
      permissions = await getPermissions();
    }
  }

  if (permissions?.user) {
    currentUser.securityGroups = permissions.user.groups ?? [];
    currentUser.userId = permissions.user.userId;
    if (!currentUser.firstName || !currentUser.lastName) {
      currentUser.firstName = permissions.user.givenName;
      currentUser.lastName = permissions.user.familyName;
    }

    const userDictionary = (currentUser as unknown) as { [key: string]: any };
    Object.keys(permissions.user)
      .filter(key => !["firstName", "lastName", "userId", "groups"].includes(key))
      .forEach(key => {
        userDictionary[key] = permissions.user[key];
      });

    const initialUrl = getInitialUrl();
    if (
      initialUrl !== "" &&
      window.location.href !== initialUrl &&
      !initialUrl.toLowerCase().includes("login") &&
      !initialUrl.toLowerCase().includes("logout")
    ) {
      window.history.pushState({}, "", initialUrl);
    }
    setInitialUrl("");
  }

  channel.publish("axp-login", currentUser);
  return currentUser;
};

registerAllApplications();
initializeSecurity()
  .catch(reason => {
    console.log("error setting current user", reason);
  })
  .finally(() => {
    console.log(currentUser);
    // This must be the last function call
    start();
  });
